
<template>
  <div class="GroupBulkShelvesContent">
    <BulkShelvesContent
      ref="BulkShelvesContentRef"
      origin="hyc"
      :smallShopItem="true"
      :openEdit="openEditDialog"
      :closeEdit="closeEditDialog"
      @iframeClose="iframeClose"
    ></BulkShelvesContent>
    <EditDialog ref="editDialog" />
    <BulkShelvesResults
      ref="bulkShelvesResults"
      :publishSpeedResult="publishResult"
      :percentage="publishPercenttage"
      :pageId="pageId"
    />
  </div>
</template>

<script>
import BulkShelvesContent from '@components/prod/center/BasicComps/BulkShelvesContent';
import BulkShelvesResults from "@/components/prod/center/dialogs/bulkShelvesResults.vue";
import EditDialog from '@/components/prod/center/dialogs/EditDialog.vue';
import { mapGetters } from 'vuex';
import { getDetailByOceanItemIds } from '@/api/base/index.js';

export default {
  components: {
    BulkShelvesContent,
    EditDialog,
    BulkShelvesResults
  },
  
  data() {
      return {
          pageId: 'd_goods',
          mockEventData: {},
          ids:[]
    };
    },
  mounted() {
      window.addEventListener('message', this.receiveMessage, false);
      this.$nextTick(() => {
            window.parent.postMessage({ data: { isMounted: true }, eventName: 'mounted' },'*'); 
       });
  },
  computed: {
    ...mapGetters([
      "speedResult",
      "speedPercentage",
      "speedResultVisible",
    ]),
    publishResult() {
      return this.speedResult(this.pageId);
    },
    publishPercenttage() {
      return this.speedPercentage(this.pageId);
    },
    bulkShelvesResultsVisible() {
      return this.speedResultVisible(this.pageId)
    },
  },

  watch: {
    bulkShelvesResultsVisible(v) {
      // window.parent.postMessage({ data: { speedResultVisible: v  }, eventName: 'speedResultVisible' }, '*');
    }
  },

  methods: {
    receiveMessage (event) {
      const { data = {}, eventName } = event.data;
      if (eventName == 'open') {
        let { type, list=[] } = data.publishParams || {};
        let rows = list, configs = {};
        configs = {
            publishType: 'PUBLISH_ITEM',    // 铺货类型 publishType: PUBLISH_ITEM - 铺货   EDIT_ITEM - 更新铺货
            publishEntrance: 0,    // 铺货入口 publishEntrance:  0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货
        };
        this.$refs.BulkShelvesContentRef.method_open(type, rows, configs);

        // let { type, list } = data.publishParams || {};
        // let rows = [], configs = {};
        // const params = {
        //     supplyItemInfoList: list || []
        // };
        // getDetailByOceanItemIds(params).then((res) => {
        //     rows = res.data || [];
        //     if (rows.length == 0) {
        //         this.$message.error('不存在分销数据，请仔细检查！');
        //         return;
        //     }
        //     /**
        //      * 举例：
        //      * type: 'single', 'multi'  单个铺货， 批量铺货
        //      if(type === 'single') {
        //     configs = {
        //         isDistributor: true,    // 是否是分销商
        //         canPublishPlatform: rows[0].canPublishPlatform,  // 可铺货平台
        //         publishType: 'PUBLISH_ITEM',    // 铺货类型 publishType: PUBLISH_ITEM - 铺货   EDIT_ITEM - 更新铺货
        //         publishEntrance: 2,    // 铺货入口 publishEntrance:  0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货
        //     };
        //     } else if(type === 'multi') {
        //         configs = {
        //         publishType: 'PUBLISH_ITEM',
        //         publishEntrance: 2
        //     };
        //     }
        //     */
        //     configs = {
        //         isDistributor: false,    // 是否是分销商
        //         canPublishPlatform: rows[0].canPublishPlatform,  // 可铺货平台
        //         publishType: 'PUBLISH_ITEM',    // 铺货类型 publishType: PUBLISH_ITEM - 铺货   EDIT_ITEM - 更新铺货
        //         publishEntrance: 0,    // 铺货入口 publishEntrance:  0-商品资料铺货  1-分销商品铺货  2-供销商展架铺货
        //     };
    
        //     this.$refs.BulkShelvesContentRef.method_open(type, rows, configs);
        // });
            
      } else if ('closeDialog') {
      }
    },
    openEditDialog(params, extraParams) {
      this.$refs.editDialog.method_open(params, extraParams);
    },
    closeEditDialog() {
      this.$refs.editDialog.method_close();
    },
    iframeClose(visible) {
      console.log('iframeClose', visible);
        if (!visible) {
            window.parent.postMessage({ data: {  }, eventName: 'modalClose' }, '*');
            return;
        }
    },
  },
};
</script>

<style lang='scss' scoped>
    .GroupBulkShelvesContent{
        width: 800px;
        margin: 20px auto;
    }
</style>
